import * as React from "react";
import { Layout } from "antd";
import { useFindAllCategories } from "@njoy/controller";

import { HeaderAlt } from "./Headers/HeaderAlt";
import { HeaderSub } from "./Headers/HeaderSub";
import { HeaderPlain } from "./Headers/HeaderPlain";
import { MobileTab } from "./MobileTab";

// const category = [
//   {
//     id: 1,
//     name: "Food & Entertainment"
//   }
// ];

interface Props {
  page?: any;
  children: any;
  hasComponent?: boolean;
  component?: React.ReactNode;
  isCentered?: boolean;
  bgImg?: string;
  showNavBar?: boolean;
  icon?: React.ReactNode;
}

function C({
  page,
  children,
  hasComponent = false,
  component,
  isCentered = true,
  bgImg,
  showNavBar = true,
  icon,
}: Props) {
  const { Content } = Layout;
  const { categories } = useFindAllCategories();
  // const { categories } = this.props;

  const headerAltPages = [
    "Confirm Transaction",
    "Redeem Offer",
    "Enter OTP",
    "All Perks",
    "About Us",
    "Connect ID",
    "Points Overview",
    "Redemption History",
    "Redemption Details",
    "Legal",
    "Help & Support",
    "Referral",
    "Privacy Policy",
    "Terms & Conditions",
    "App Settings",
    "Transaction Limit",
    "Confirm Transaction Limit",
    "Account Details",
    "Change Email Address",
    "Personal Details",
    "Change Phone Number",
    "Change Password",
    "Change PIN",
    "Confirm PIN",
    "Close Account",
    "Manage ID Cards",
    "Send Money",
    "All Brands",
    "Current PIN",
    "Reverify Account",
  ];

  return (
    <React.Fragment>
      <div className="min-h-screen flex flex-col w-full">
        <div className="w-full flex flex-col flex-1">
          <div className="w-full flex flex-col  flex-1">
            <div className="!sticky  w-full z-50">
              {/* 1st level pages */}
              {(page === "Discover" ||
                page === "Wallet" ||
                page === "Alerts" ||
                page === "Profile") && <HeaderPlain pageTitle={page} />}

              {/* 2nd level pages */}
              {(headerAltPages.includes(page) ||
                (categories && categories.some((c) => c.name === page))) && (
                <HeaderAlt
                  hasComponent={hasComponent}
                  isCentered={isCentered}
                  component={component}
                  pageTitle={page}
                  icon={icon}
                />
              )}

              {/* 3rd level pages */}
              {(page === "Merchant Offers" || page === "View Offer") && (
                <HeaderSub pageTitle={page} bgImg={bgImg} icon={icon} />
              )}
            </div>

            <Content className="flex-1 flex flex-col">{children}</Content>
          </div>

          <div className="sticky bottom-0 left-0 right-0 w-full z-50">
            {showNavBar ? <MobileTab offset={0} limit={1} /> : null}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export const TemplateSub = C;
